
import {PropType, toRefs} from "vue";
import {EventType} from "@/store/store.event.type";
import SvgIcon from "@/components/common/SvgIcon.vue";
import router from "@/router";
import i18n from "@/locales";

export default {
  name: "HappeningOverviewSingle",
  components: {SvgIcon},
  props: {
    item: {
      type: Object as PropType<EventType>,
      required: true,
    }
  },
  setup(props: any) {
    const {item} = toRefs(props);
    const onMoreClicked = () => {
      router.push({
        name: 'Details',
        params: {
          category: "event",
          lang: i18n.global.locale,
          id: item.value.EventId,
        }
      });
    }

    return {
      onMoreClicked,
    }
  }
}
